// DS: UI11
import React, { useCallback } from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import LinkArrowIcon from '@wix/da-ds/pkg/Icons/LinkArrow';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ViewReplies.scss';
// If it will be reused please extract it into its own component.
const ViewReplies = ({ className , children , onClick  })=>{
    const clickHandler = useCallback((e)=>onClick(), [
        onClick
    ]);
    return /*#__PURE__*/ React.createElement(Flex, {
        className: s['root'],
        alignItems: "center",
        onClick: clickHandler
    }, /*#__PURE__*/ React.createElement(LinkArrowIcon, {
        className: s['icon'],
        size: IconSize.MEDIUM
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['text']
    }, children));
};
ViewReplies.displayName = 'ViewReplies';
export default ViewReplies;
